import { ISelectItem } from '@lla-platform/core/core-ui'

export enum CallSentiment {
  Unknown = 'Unknown',
  Positive = 'Positive',
  Neutral = 'Neutral',
  Frustrated = 'Frustrated',
  Angry = 'Angry'
}

export const CallSentimentToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  Positive: 'Positive',
  Neutral: 'Neutral',
  Frustrated: 'Frustrated',
  Angry: 'Angry'
}

export const CallSentimentItems: ISelectItem[] = Object.values(CallSentiment).map((value) => ({
  label: CallSentimentToLabel[value],
  value
}))
